import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/**
 * Şehir ekle/düzenle form şeması (026): nameTr zorunlu; nameEn opsiyonel. Sıra formda yok (ülke kapsamında
 * tablodaki ↑/↓ oklarından). Ülke seçimi form dışıdır (seçili ülke path'ten gelir).
 */
export const cityFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type CityFormValues = z.infer<typeof cityFormSchema>
